import { dropHelpers } from '@/_helpers'


// Default length sum
const LENGTH_CONSTANT = 10
// Default custom pallets widths
const CUSTOM_PALLET_WIDTHS = [40, 50, 60, 75, 90, 100, 120, null]

// Height to width ratio to calculate width of the pallet
const HEIGHT_TO_WIDTH_RATIO = 1.1 // height = 1.1 * width

// Max weight of the pallet
const PALLET_WEIGHT_MAX = 1500000 // Grams

// Default height of the pallet
const HEIGHT_OF_PALLET = 15 // CM

// const EUR_PALLET_WIDTH_MIN = 80 // CM
const EUR_PALLET_WIDTH_MAX = 80 // CM
// const EUR_PALLET_LENGTH_MIN = 120 // CM
const EUR_PALLET_LENGTH_MAX = 120 // CM
const EDGE_RESERVE = 5 // CM

// Define warnings
const PALLET_WARNINGS = [
  {
    warning: ({ dimensions }) => (dimensions.height / dimensions.width > 1.1),
    msg: 'max_height_width_ratio_exceeded'
  },
  {
    warning: ({ weight }) => (weight > PALLET_WEIGHT_MAX),
    msg: 'max_weight_exceeded'
  }
]
const EURO_PALLET_WARNINGS = [
  {
    warning: ({ dimensions }) => (dimensions.calculatedLength > EUR_PALLET_LENGTH_MAX - (EDGE_RESERVE * 2)),
    msg: 'max_length_exceeded'
  },
  {
    warning: ({ dimensions }) => (dimensions.calculatedWidth > EUR_PALLET_WIDTH_MAX),
    msg: 'max_width_exceeded'
  },
  {
    warning: ({ weight }) => (weight > PALLET_WEIGHT_MAX),
    msg: 'max_weight_exceeded'
  }
]

// Calculate the longest dimension of  units/boxes arrays between width and length
const longestBox = (units) => {
  return units.reduce((a, b) => {
    const maxEdge = Math.max(b.dimensions.width, b.dimensions.length)
    return Math.max(a, maxEdge)
  }, 0)
}
// Calculate Pallet Weight
const palletWeight = (units) => {
  return units.reduce((weight, unit) => {
    return weight += dropHelpers.calculateUnitWeight(unit)
  }, 0)
}
// Calculate Pallet volume which is the summary of all units/boxes volume
const palletVolume = (units) => {
  return units.reduce((volume, unit) => {
    return volume += unitVolume(unit.dimensions.length, unit.dimensions.width, unit.dimensions.height)
  }, 0)
}

// Volume of one unit/box
const unitVolume = (length, width, height) => {
  return length * width * height
}

// Height of the pallet
const palletHeight = (volume, length, width) => {
  return Math.ceil((volume / length) / width) + HEIGHT_OF_PALLET
}
// Length of the pallet, input longest dimension of all boxes
const palletLength = (longest) => {
  return Math.ceil(longest + LENGTH_CONSTANT)
}

// Calculate pallet width if is not defined
const palletWidth = (units, width) => {
  if (width != null) {
    return width
  }
  return Math.ceil(Math.sqrt(palletVolume(units) / (palletLength(longestBox(units)) * HEIGHT_TO_WIDTH_RATIO)) / 10) * 10
}

const palletWarnings = (pallet) => {
  let warnings = []
  PALLET_WARNINGS.forEach(({ warning, msg }) => {
    if (warning(pallet)) {
      warnings.push(msg)
    }
  })
 return { ...pallet, warnings }
}

const euroPalletWarnings = (pallet) => {
  let warnings = []
  EURO_PALLET_WARNINGS.forEach(({ warning, msg }) => {
    if (warning(pallet)) {
      warnings.push(msg)
    }
  })
 return { ...pallet, warnings }
}

// Array of all available custom pallets
export const availableCustomPallets = (units, widths = CUSTOM_PALLET_WIDTHS) => {
  return widths.map((width) => {
    return palletWarnings({
      dimensions: {
        length: palletLength(longestBox(units)),
        width: palletWidth(units, width),
        height: palletHeight(palletVolume(units), palletLength(longestBox(units)), palletWidth(units, width))
      },
      weight: palletWeight(units),
      volume: palletVolume(units),
      type: `CustomPallet${width != null ? width : ''}`,
      warnings: []
    })
  })
}
// Array of all available euro pallets
export const availableEuroPallet = (units, length = 120, width = 80) => {
  return [
    euroPalletWarnings({
      dimensions: {
        width,
        length,
        calculatedLength: palletLength(longestBox(units)),
        calculatedWidth: palletWidth(units, width),
        height: palletHeight(palletVolume(units), palletLength(longestBox(units)), width)
      },
      weight: palletWeight(units),
      volume: palletVolume(units),
      type: 'EurPallet',
      warnings: []
    })
  ]
}

export default { availableCustomPallets, availableEuroPallet }

